<form [formGroup]="signatureForm" id="signature-form">
    <ng-container *ngIf="!hideExplanation">
        <h2>Signature Setup</h2>
        <p style="margin-bottom: 2rem">
            Please type your legal name and use your mouse, finger or a stylus to create your digital signature and initials so you can sign documents
            electronically.
            <b>Please add your signature and initials close to the corresponding guidelines, so they will show up correctly on the documents.</b>
        </p>
    </ng-container>
    <div>
        <mat-form-field style="width: 100%" appearance="fill" class="w-65">
            <ng-template></ng-template>
            <mat-label>Legal name</mat-label>
            <input
                class="form-control"
                type="text"
                #legal
                matInput
                placeholder="Name used to sign legal documents"
                autocomplete="off"
                formControlName="legalName"
            />

            <mat-error>{{ errMsg }}</mat-error>
        </mat-form-field>
    </div>
    <div class="d-flex signature-container" [ngClass]="canEdit ? 'canvas-edit' : ''">
        <app-signature-capture
            [id]="ids[0]"
            [pointGroups]="signature"
            [error]="signatureError"
            [dimensions]="signatureBoxDimensions"
            [hideButton]="hideButton"
            [newImage]="newSignature"
            [canEdit]="canEdit"
            (outEvent)="eventHandler($event)"
            hintText=""
        >
        </app-signature-capture>
        <app-signature-capture
            [id]="ids[1]"
            [pointGroups]="initials"
            [error]="initialsError"
            [dimensions]="initialsBoxDimensions"
            [hideButton]="hideButton"
            [newImage]="newInitials"
            [canEdit]="canEdit"
            (outEvent)="eventHandler($event)"
            hintText=""
        >
        </app-signature-capture>
    </div>

    <ng-content></ng-content>

    <div *ngIf="canEdit" class="button-container">
        <button *ngIf="!hideCancelButton" mat-button class="secondary" type="button" (click)="signOut()">
            {{ (user?.needProfileUpdate && !welcomeFormButtons) || welcomeFormButtons ? 'Cancel & Log Out' : 'Cancel' }}
        </button>
        <button mat-button class="primary" type="button" (click)="save()">
            {{ (user?.needProfileUpdate && !welcomeFormButtons) || welcomeFormButtons ? 'Save & Continue' : 'Save' }}
        </button>
    </div>
</form>
